import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import { EndpointsService } from './endpoints.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  private _business: any;
  private _businessBanners: any;
  private theme$ = new BehaviorSubject<string>('');

  get business() {
    return this._business;
  }

  set business(value) {
    this._business = value;
  }

  set theme(color: string) {
    this.theme$.next(color);
  }

  get themeObs(): Observable<string> {
    return this.theme$.asObservable();
  }

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }

  fetchById(id: string): Observable<any> {
    this._business = this.httpService.get(this.endpoints.businessId.replace('{businessId}', id));
    return this._business;
  }

  fetchBannersById(id: string): Observable<any> {
    this._businessBanners = this.httpService.get(this.endpoints.businessBanner.replace('{businessId}', id));
    return this._businessBanners;
  }
}
